import useURLSearchParams from '/src/hooks/useURLSearchParams';
import {useEffect} from 'react';
import {useLoginEmailVerifyMutation} from '../redux/loginApi';

export default function useParseEmailVerify(){
    const [params, setParams] = useURLSearchParams();
    const [verifyEmailToken, { error: verifyError, isLoading: isVerifying, isSuccess: isVerifySuccess }] = useLoginEmailVerifyMutation();

    // handle return from emailed link (parse access token)
    useEffect(()=>{
        if(params && params['email-verify']){
            verifyEmailToken(params['email-verify']);
            // clear token from url
            setParams({});
        }
    },[params]);

    return [verifyEmailToken, { error: verifyError, isLoading: isVerifying, isSuccess: isVerifySuccess }];
}